webpackJsonp([1],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-header'
});

/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-divider',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['divider'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),

/***/ 118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4a27166_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4a27166_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4a27166_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 119:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : [];
    },
    isExternalLink: function isExternalLink() {
      if (this.url.substring(0, 4) === 'http') {
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),

/***/ 120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(122);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd9003dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd9003dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd9003dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 122:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  },
  methods: {
    hideMobile: function hideMobile() {
      if (document.body.classList.contains('sidebar-mobile-show')) {
        document.body.classList.toggle('sidebar-mobile-show');
      }
    }
  }
});

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarNavItem__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarNavLink__ = __webpack_require__(118);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-label',
  components: {
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_1__SidebarNavItem__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_2__SidebarNavLink__["a" /* default */]
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: '#'
    },
    icon: {
      type: String,
      default: 'fa fa-circle'
    },
    classes: {
      type: String,
      default: ''
    },
    label: {
      type: Object,
      required: true,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      var classes = {
        navItem: ['hidden-cn'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.getClasses(this.classes))).join(' '),
        navLink: 'nav-label',
        icon: [this.icon ? this.icon : 'fa fa-circle', this.label.variant ? 'text-' + this.label.variant : '', this.label.class ? this.label.class : ''].join(' ')
      };
      return classes;
    }
  },
  methods: {
    getClasses: function getClasses(classes) {
      return classes ? classes.split(' ') : [];
    }
  }
});

/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_LineExample__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_PieExample__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_BarExample__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'story',
  data: function data() {
    return {
      labels_app: ['label'],
      data_app: [12],

      labels_app_social: ['Facebook', 'Tumblr', 'Instagram', 'Snapchat'],
      data_app_social: [42.8, 5.6, 30.2, 21.4],
      pie_colors_app_social: ['#3b5998', '#35465c', '#c13584', '#fffc00'],

      labels_app_music: ['iTunes', 'Spotify', 'Misc. audio', 'Pandora'],
      data_app_music: [64.3, 20.1, 8.4, 7.2],
      pie_colors_app_music: ['#6762a6', '#1db954', '#28353d', '#005483'],
      labels_app_video: ['YouTube', 'Misc. video', 'Netflix'],
      data_app_video: [68.6, 13.5, 17.8],
      pie_colors_app_video: ['#ff0000', '#564d4d', '#831010'],
      labels_mobile: ['Apple', 'Samsung', 'Murata Mfg', 'Intel', 'Kyocera', 'Motorola', 'HTC', 'Huawei Tech'],
      data_mobile: [6544, 742, 420, 531, 140, 153, 360, 119],
      pie_colors_mobile: ['#5270ff', '#E46651', '#00D8FF', '#41B883', '#00BCD4', '#03A9F4', '#009688', '#673AB7', '#3F51B5', '#2196F3', '#F44336', '#E91E63', '#9C27B0', '#4CAF50', '#FFEB3B', '#CDDC39', '#FFC107', '#FF9800', '#FF5722', '#795548', '#607D8B', '#9E9E9E'],

      labels_events: ['Festivals', 'Fridays After Five', 'General', 'Holiday', 'Kids Event', 'Movie', 'Speaker/Performance', 'Theme Week'],
      data_events: [171, 212, 111, 102, 90, 101, 136, 95],
      green_colors_events: ['#C2E79A', '#92C060', '#699A33', '#457313', '#284D00', '#C2E79A', '#92C060', '#699A33'],

      labels_dates: ['Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat', 'Sun'],
      data_dates: [96, 112, 121, 119, 154, 134, 94],
      default_pie_colors: ['#41B883', '#E46651', '#00D8FF', '#DD1B16', '#00BCD4', '#03A9F4', '#009688', '#673AB7', '#3F51B5', '#2196F3', '#F44336', '#E91E63', '#9C27B0', '#4CAF50', '#FFEB3B', '#CDDC39', '#FFC107', '#FF9800', '#FF5722', '#795548', '#607D8B', '#9E9E9E']
    };
  },

  components: {
    LineExample: __WEBPACK_IMPORTED_MODULE_0__charts_LineExample__["a" /* default */],
    PieExample: __WEBPACK_IMPORTED_MODULE_1__charts_PieExample__["a" /* default */],
    BarExample: __WEBPACK_IMPORTED_MODULE_2__charts_BarExample__["a" /* default */],
    Carousel: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_3_vue_carousel__["Slide"]
  }
});

/***/ }),

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_clients_per_day_json__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_clients_per_day_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_clients_per_day_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_clients_per_month_json__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_clients_per_month_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_clients_per_month_json__);





/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  data: function data() {
    return {
      timeline: __WEBPACK_IMPORTED_MODULE_1__static_clients_per_day_json___default.a
    };
  },
  mounted: function mounted() {
    console.log(__WEBPACK_IMPORTED_MODULE_1__static_clients_per_day_json___default.a);
    var clients = [];
    var date = [];

    __WEBPACK_IMPORTED_MODULE_1__static_clients_per_day_json___default.a.data.forEach(function (element) {
      clients.push(element.client);
      var tempDate = new Date(element.date);
      date.push(tempDate.getMonth() + 1 + '/' + tempDate.getDate() + '/' + tempDate.getFullYear());
    });
    var monthCount = [];
    var months = [];
    __WEBPACK_IMPORTED_MODULE_2__static_clients_per_month_json___default.a.data.forEach(function (element) {
      monthCount.push(element.client);
      months.push(element.date);
    });

    this.renderChart({
      labels: months,
      datasets: [{
        label: 'Monthly Wifi Users',
        backgroundColor: '#63c2de',
        data: monthCount
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieExample_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieExample_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(37);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["c" /* Pie */],
  props: ['labels', 'dataPoints', 'pieColors'],
  mounted: function mounted() {
    this.renderChart({
      labels: this.labels,
      datasets: [{
        backgroundColor: this.pieColors,
        data: this.dataPoints
      }]
    }, { responsive: true, maintainAspectRatio: false });
  }
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(37);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  props: ['labels', 'dataPoints'],
  mounted: function mounted() {
    this.renderChart({
      labels: this.labels,
      datasets: [{
        label: 'Average Number of Wifi Users',
        backgroundColor: ['#BA55D3', '#8A2BE2', '#800080', '#9932CC', '#4B0082', '#800080', '#8B008B'],
        data: this.dataPoints
      }]
    });
  }
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_BarExample__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_BarSessions__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_LineExample__ = __webpack_require__(56);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'model',
  components: {
    BarExample: __WEBPACK_IMPORTED_MODULE_0__charts_BarExample__["a" /* default */],
    BarSessions: __WEBPACK_IMPORTED_MODULE_1__charts_BarSessions__["a" /* default */],
    LineExample: __WEBPACK_IMPORTED_MODULE_2__charts_LineExample__["a" /* default */]
  }
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(37);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  mounted: function mounted() {
    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      datasets: [{
        label: 'GitHub Commits',
        backgroundColor: '#f87979',
        data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20, 12, 11]
      }]
    });
  }
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_carousel__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["d" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["e" /* Sidebar */],
    AppAside: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Aside */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components___["c" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components___["b" /* Breadcrumb */],
    Carousel: __WEBPACK_IMPORTED_MODULE_2_vue_carousel__["Carousel"],
    Slide: __WEBPACK_IMPORTED_MODULE_2_vue_carousel__["Slide"]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__charts_LineExample__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__charts_PieExample__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__charts_BarExample__ = __webpack_require__(57);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'story',
  data: function data() {
    return {
      labels_app: ['label'],
      data_app: [12],

      labels_app_social: ['Facebook', 'Tumblr', 'Instagram', 'Snapchat'],
      data_app_social: [42.8, 5.6, 30.2, 21.4],

      labels_app_music: ['iTunes', 'Spotify', 'Misc. audio', 'Pandora'],
      data_app_music: [64.3, 20.1, 8.4, 7.2],

      labels_app_video: ['YouTube', 'Misc. video', 'Netflix'],
      data_app_video: [68.6, 13.5, 17.8],
      labels_mobile: ['Apple', 'Samsung', 'Murata Mfg', 'Intel', 'Kyocera', 'Motorola', 'HTC', 'Huawei Tech'],
      data_mobile: [6544, 742, 420, 531, 140, 153, 230, 360, 119, 75],

      labels_events: ['Festivals', 'Fridays After Five', 'General', 'Holiday', 'Kids Event', 'Movie', 'Speaker/Performance', 'Theme Week'],
      data_events: [172, 212, 111, 102, 90, 101, 136, 95],

      labels_dates: ['Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat', 'Sun'],
      data_dates: [96, 112, 121, 119, 154, 134, 94]
    };
  },

  components: {
    LineExample: __WEBPACK_IMPORTED_MODULE_0__charts_LineExample__["a" /* default */],
    PieExample: __WEBPACK_IMPORTED_MODULE_1__charts_PieExample__["a" /* default */],
    BarExample: __WEBPACK_IMPORTED_MODULE_2__charts_BarExample__["a" /* default */]
  }
});

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(368);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
  }
});

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 307:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 350:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(90);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5562bba9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
function injectStyle (context) {
  __webpack_require__(365)
  __webpack_require__(366)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5562bba9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5562bba9_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 365:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 366:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []


/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Full__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Story__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Model__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Home__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Data__ = __webpack_require__(503);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_5__views_Home__["a" /* default */]
  }, {
    path: '/',
    redirect: '/story',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    children: [{
      path: 'story',
      name: 'Story',
      component: __WEBPACK_IMPORTED_MODULE_3__views_Story__["a" /* default */]
    }, {
      path: 'model',
      name: 'Model',
      component: __WEBPACK_IMPORTED_MODULE_4__views_Model__["a" /* default */]
    }, {
      path: 'data',
      name: 'Data',
      component: __WEBPACK_IMPORTED_MODULE_6__views_Data__["a" /* default */]
    }]
  }]
}));

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cdf2020_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cdf2020_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cdf2020_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(94);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d54f652_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d54f652_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d54f652_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"})}
var staticRenderFns = []


/***/ }),

/***/ 373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(95);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0baf84bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0baf84bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0baf84bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 374:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}))}
var staticRenderFns = []


/***/ }),

/***/ 375:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(96);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63892fc1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63892fc1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63892fc1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 376:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),

/***/ 377:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(97);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_152f873e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_152f873e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_152f873e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',[_vm._v(" Team HACK'D © 2018 ")]),_vm._v(" "),_c('span',{staticClass:"ml-auto"},[_vm._v("Powered by "),_c('a',{attrs:{"href":"http://coreui.io"}},[_vm._v("CoreUI")])])])}]


/***/ }),

/***/ 379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(98);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_263bc0a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_263bc0a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_263bc0a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('span',{staticClass:"font-weight-normal ml-4 mt-1 h4"},[_vm._v("Team HACK'D")]),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-navbar-nav',{},[_c('router-link',{staticClass:"px-3 nav-link",attrs:{"to":'/'}},[_vm._v("Home")]),_vm._v(" "),_c('router-link',{staticClass:"px-3 nav-link",attrs:{"to":'story'}},[_vm._v("Story")])],1),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"})],1)}
var staticRenderFns = []


/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(99);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1a45508_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
function injectStyle (context) {
  __webpack_require__(382)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1a45508_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1a45508_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 382:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 383:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_145e7210_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_145e7210_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_145e7210_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(101);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d71480fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d71480fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d71480fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(102);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63fde22a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63fde22a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63fde22a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),

/***/ 389:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(103);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f743908_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f743908_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f743908_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []


/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__ = __webpack_require__(104);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d090ec0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d090ec0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d090ec0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList})}
var staticRenderFns = []


/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(117);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81543e2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81543e2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81543e2a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []


/***/ }),

/***/ 422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternalLink)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(120);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f39daee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f39daee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f39daee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []


/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList,on:{"click":_vm.hideMobile}},[_vm._t("default")],2)}
var staticRenderFns = []


/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLabel_vue__ = __webpack_require__(123);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48ac2ade_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48ac2ade_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48ac2ade_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SidebarNavItem',{attrs:{"classes":_vm.classList.navItem}},[_c('a',{class:_vm.classList.navLink,attrs:{"href":_vm.url}},[_c('i',{class:_vm.classList.icon}),_vm._v(" "+_vm._s(_vm.name))])])}
var staticRenderFns = []


/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return [(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('SidebarNavDivider',{attrs:{"classes":item.class}})]:(item.label)?[_c('SidebarNavLabel',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"label":item.label,"classes":item.class}})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}))]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []


/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(124);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83d8cbf4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83d8cbf4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83d8cbf4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []


/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1),_vm._v(" "),_c('AppAside')],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []


/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Story_vue__ = __webpack_require__(125);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_558be3f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Story_vue__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Story_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_558be3f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Story_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_558be3f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Story_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 130,
	"./af.js": 130,
	"./ar": 131,
	"./ar-dz": 132,
	"./ar-dz.js": 132,
	"./ar-kw": 133,
	"./ar-kw.js": 133,
	"./ar-ly": 134,
	"./ar-ly.js": 134,
	"./ar-ma": 135,
	"./ar-ma.js": 135,
	"./ar-sa": 136,
	"./ar-sa.js": 136,
	"./ar-tn": 137,
	"./ar-tn.js": 137,
	"./ar.js": 131,
	"./az": 138,
	"./az.js": 138,
	"./be": 139,
	"./be.js": 139,
	"./bg": 140,
	"./bg.js": 140,
	"./bn": 141,
	"./bn.js": 141,
	"./bo": 142,
	"./bo.js": 142,
	"./br": 143,
	"./br.js": 143,
	"./bs": 144,
	"./bs.js": 144,
	"./ca": 145,
	"./ca.js": 145,
	"./cs": 146,
	"./cs.js": 146,
	"./cv": 147,
	"./cv.js": 147,
	"./cy": 148,
	"./cy.js": 148,
	"./da": 149,
	"./da.js": 149,
	"./de": 150,
	"./de-at": 151,
	"./de-at.js": 151,
	"./de-ch": 152,
	"./de-ch.js": 152,
	"./de.js": 150,
	"./dv": 153,
	"./dv.js": 153,
	"./el": 154,
	"./el.js": 154,
	"./en-au": 155,
	"./en-au.js": 155,
	"./en-ca": 156,
	"./en-ca.js": 156,
	"./en-gb": 157,
	"./en-gb.js": 157,
	"./en-ie": 158,
	"./en-ie.js": 158,
	"./en-nz": 159,
	"./en-nz.js": 159,
	"./eo": 160,
	"./eo.js": 160,
	"./es": 161,
	"./es-do": 162,
	"./es-do.js": 162,
	"./es.js": 161,
	"./et": 163,
	"./et.js": 163,
	"./eu": 164,
	"./eu.js": 164,
	"./fa": 165,
	"./fa.js": 165,
	"./fi": 166,
	"./fi.js": 166,
	"./fo": 167,
	"./fo.js": 167,
	"./fr": 168,
	"./fr-ca": 169,
	"./fr-ca.js": 169,
	"./fr-ch": 170,
	"./fr-ch.js": 170,
	"./fr.js": 168,
	"./fy": 171,
	"./fy.js": 171,
	"./gd": 172,
	"./gd.js": 172,
	"./gl": 173,
	"./gl.js": 173,
	"./gom-latn": 174,
	"./gom-latn.js": 174,
	"./he": 175,
	"./he.js": 175,
	"./hi": 176,
	"./hi.js": 176,
	"./hr": 177,
	"./hr.js": 177,
	"./hu": 178,
	"./hu.js": 178,
	"./hy-am": 179,
	"./hy-am.js": 179,
	"./id": 180,
	"./id.js": 180,
	"./is": 181,
	"./is.js": 181,
	"./it": 182,
	"./it.js": 182,
	"./ja": 183,
	"./ja.js": 183,
	"./jv": 184,
	"./jv.js": 184,
	"./ka": 185,
	"./ka.js": 185,
	"./kk": 186,
	"./kk.js": 186,
	"./km": 187,
	"./km.js": 187,
	"./kn": 188,
	"./kn.js": 188,
	"./ko": 189,
	"./ko.js": 189,
	"./ky": 190,
	"./ky.js": 190,
	"./lb": 191,
	"./lb.js": 191,
	"./lo": 192,
	"./lo.js": 192,
	"./lt": 193,
	"./lt.js": 193,
	"./lv": 194,
	"./lv.js": 194,
	"./me": 195,
	"./me.js": 195,
	"./mi": 196,
	"./mi.js": 196,
	"./mk": 197,
	"./mk.js": 197,
	"./ml": 198,
	"./ml.js": 198,
	"./mr": 199,
	"./mr.js": 199,
	"./ms": 200,
	"./ms-my": 201,
	"./ms-my.js": 201,
	"./ms.js": 200,
	"./my": 202,
	"./my.js": 202,
	"./nb": 203,
	"./nb.js": 203,
	"./ne": 204,
	"./ne.js": 204,
	"./nl": 205,
	"./nl-be": 206,
	"./nl-be.js": 206,
	"./nl.js": 205,
	"./nn": 207,
	"./nn.js": 207,
	"./pa-in": 208,
	"./pa-in.js": 208,
	"./pl": 209,
	"./pl.js": 209,
	"./pt": 210,
	"./pt-br": 211,
	"./pt-br.js": 211,
	"./pt.js": 210,
	"./ro": 212,
	"./ro.js": 212,
	"./ru": 213,
	"./ru.js": 213,
	"./sd": 214,
	"./sd.js": 214,
	"./se": 215,
	"./se.js": 215,
	"./si": 216,
	"./si.js": 216,
	"./sk": 217,
	"./sk.js": 217,
	"./sl": 218,
	"./sl.js": 218,
	"./sq": 219,
	"./sq.js": 219,
	"./sr": 220,
	"./sr-cyrl": 221,
	"./sr-cyrl.js": 221,
	"./sr.js": 220,
	"./ss": 222,
	"./ss.js": 222,
	"./sv": 223,
	"./sv.js": 223,
	"./sw": 224,
	"./sw.js": 224,
	"./ta": 225,
	"./ta.js": 225,
	"./te": 226,
	"./te.js": 226,
	"./tet": 227,
	"./tet.js": 227,
	"./th": 228,
	"./th.js": 228,
	"./tl-ph": 229,
	"./tl-ph.js": 229,
	"./tlh": 230,
	"./tlh.js": 230,
	"./tr": 231,
	"./tr.js": 231,
	"./tzl": 232,
	"./tzl.js": 232,
	"./tzm": 233,
	"./tzm-latn": 234,
	"./tzm-latn.js": 234,
	"./tzm.js": 233,
	"./uk": 235,
	"./uk.js": 235,
	"./ur": 236,
	"./ur.js": 236,
	"./uz": 237,
	"./uz-latn": 238,
	"./uz-latn.js": 238,
	"./uz.js": 237,
	"./vi": 239,
	"./vi.js": 239,
	"./x-pseudo": 240,
	"./x-pseudo.js": 240,
	"./yo": 241,
	"./yo.js": 241,
	"./zh-cn": 242,
	"./zh-cn.js": 242,
	"./zh-hk": 243,
	"./zh-hk.js": 243,
	"./zh-tw": 244,
	"./zh-tw.js": 244
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 464;

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@3.1.0","C:\\Users\\halee.mason\\Documents\\hack-cville\\web"]],"_from":"vue-chartjs@3.1.0","_id":"vue-chartjs@3.1.0","_inBundle":false,"_integrity":"sha512-cp70zluNJdN57J907hSzjp4jayF6O0ayBJ/alZprHx+BvbVe+nL+QF3TOPSSao3UoenCopYJybmDi/RWYb7afw==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@3.1.0","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"3.1.0","saveSpec":null,"fetchSpec":"3.1.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-3.1.0.tgz","_spec":"3.1.0","_where":"C:\\Users\\halee.mason\\Documents\\hack-cville\\web","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"@babel/cli":"^7.0.0-beta.31","@babel/core":"^7.0.0-beta.31","@babel/preset-env":"^7.0.0-beta.31","@babel/preset-stage-2":"^7.0.0-beta.31","babel-loader":"8.0.0-beta.0","chai":"^3.5.0","chart.js":"2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^5.1.1","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^3.0.1","file-loader":"^0.10.1","friendly-errors-webpack-plugin":"^1.6.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta":"^4.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"2","lolex":"^1.6.0","mocha":"^3.1.0","opn":"^5.1.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","portfinder":"^1.0.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"2.5.2","vue-hot-reload-api":"2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^13.3.0","vue-style-loader":"3.0.1","vue-template-compiler":"2.5.2","webpack":"^3.7.1","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"^4.1.0"},"engines":{"node":">=6.9.0","npm":">= 3.0.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"2.7.x"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublishOnly":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && cross-env NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.min.js","version":"3.1.0"}

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

module.exports = {"data":[{"date":"2017/01/01 05:00:00.000000 +00:00","client":"93"},{"date":"2017/01/02 05:00:00.000000 +00:00","client":"73"},{"date":"2017/01/03 05:00:00.000000 +00:00","client":"87"},{"date":"2017/01/04 05:00:00.000000 +00:00","client":"97"},{"date":"2017/01/05 05:00:00.000000 +00:00","client":"92"},{"date":"2017/01/06 05:00:00.000000 +00:00","client":"88"},{"date":"2017/01/07 05:00:00.000000 +00:00","client":"39"},{"date":"2017/01/08 05:00:00.000000 +00:00","client":"40"},{"date":"2017/01/09 05:00:00.000000 +00:00","client":"74"},{"date":"2017/01/10 05:00:00.000000 +00:00","client":"67"},{"date":"2017/01/11 05:00:00.000000 +00:00","client":"88"},{"date":"2017/01/12 05:00:00.000000 +00:00","client":"105"},{"date":"2017/01/13 05:00:00.000000 +00:00","client":"150"},{"date":"2017/01/14 05:00:00.000000 +00:00","client":"94"},{"date":"2017/01/15 05:00:00.000000 +00:00","client":"74"},{"date":"2017/01/16 05:00:00.000000 +00:00","client":"95"},{"date":"2017/01/17 05:00:00.000000 +00:00","client":"83"},{"date":"2017/01/18 05:00:00.000000 +00:00","client":"108"},{"date":"2017/01/19 05:00:00.000000 +00:00","client":"104"},{"date":"2017/01/20 05:00:00.000000 +00:00","client":"109"},{"date":"2017/01/21 05:00:00.000000 +00:00","client":"122"},{"date":"2017/01/22 05:00:00.000000 +00:00","client":"69"},{"date":"2017/01/23 05:00:00.000000 +00:00","client":"55"},{"date":"2017/01/24 05:00:00.000000 +00:00","client":"96"},{"date":"2017/01/25 05:00:00.000000 +00:00","client":"135"},{"date":"2017/01/26 05:00:00.000000 +00:00","client":"119"},{"date":"2017/01/27 05:00:00.000000 +00:00","client":"97"},{"date":"2017/01/28 05:00:00.000000 +00:00","client":"88"},{"date":"2017/01/29 05:00:00.000000 +00:00","client":"61"},{"date":"2017/01/30 05:00:00.000000 +00:00","client":"61"},{"date":"2017/01/31 05:00:00.000000 +00:00","client":"138"},{"date":"2017/02/01 05:00:00.000000 +00:00","client":"85"},{"date":"2017/02/02 05:00:00.000000 +00:00","client":"92"},{"date":"2017/02/03 05:00:00.000000 +00:00","client":"104"},{"date":"2017/02/04 05:00:00.000000 +00:00","client":"87"},{"date":"2017/02/05 05:00:00.000000 +00:00","client":"58"},{"date":"2017/02/06 05:00:00.000000 +00:00","client":"98"},{"date":"2017/02/07 05:00:00.000000 +00:00","client":"99"},{"date":"2017/02/08 05:00:00.000000 +00:00","client":"154"},{"date":"2017/02/09 05:00:00.000000 +00:00","client":"78"},{"date":"2017/02/10 05:00:00.000000 +00:00","client":"115"},{"date":"2017/02/11 05:00:00.000000 +00:00","client":"119"},{"date":"2017/02/12 05:00:00.000000 +00:00","client":"132"},{"date":"2017/02/13 05:00:00.000000 +00:00","client":"98"},{"date":"2017/02/14 05:00:00.000000 +00:00","client":"89"},{"date":"2017/02/15 05:00:00.000000 +00:00","client":"92"},{"date":"2017/02/16 05:00:00.000000 +00:00","client":"81"},{"date":"2017/02/17 05:00:00.000000 +00:00","client":"140"},{"date":"2017/02/18 05:00:00.000000 +00:00","client":"162"},{"date":"2017/02/19 05:00:00.000000 +00:00","client":"147"},{"date":"2017/02/20 05:00:00.000000 +00:00","client":"138"},{"date":"2017/02/21 05:00:00.000000 +00:00","client":"112"},{"date":"2017/02/22 05:00:00.000000 +00:00","client":"94"},{"date":"2017/02/23 05:00:00.000000 +00:00","client":"155"},{"date":"2017/02/24 05:00:00.000000 +00:00","client":"191"},{"date":"2017/02/25 05:00:00.000000 +00:00","client":"116"},{"date":"2017/02/26 05:00:00.000000 +00:00","client":"75"},{"date":"2017/02/27 05:00:00.000000 +00:00","client":"87"},{"date":"2017/02/28 05:00:00.000000 +00:00","client":"93"},{"date":"2017/03/01 05:00:00.000000 +00:00","client":"106"},{"date":"2017/03/02 05:00:00.000000 +00:00","client":"110"},{"date":"2017/03/03 05:00:00.000000 +00:00","client":"96"},{"date":"2017/03/04 05:00:00.000000 +00:00","client":"97"},{"date":"2017/03/05 05:00:00.000000 +00:00","client":"53"},{"date":"2017/03/06 05:00:00.000000 +00:00","client":"82"},{"date":"2017/03/07 05:00:00.000000 +00:00","client":"97"},{"date":"2017/03/08 05:00:00.000000 +00:00","client":"127"},{"date":"2017/03/09 05:00:00.000000 +00:00","client":"128"},{"date":"2017/03/10 05:00:00.000000 +00:00","client":"101"},{"date":"2017/03/11 05:00:00.000000 +00:00","client":"114"},{"date":"2017/03/12 05:00:00.000000 +00:00","client":"62"},{"date":"2017/03/13 05:00:00.000000 +00:00","client":"66"},{"date":"2017/03/14 05:00:00.000000 +00:00","client":"63"},{"date":"2017/03/15 05:00:00.000000 +00:00","client":"75"},{"date":"2017/03/16 05:00:00.000000 +00:00","client":"107"},{"date":"2017/03/17 05:00:00.000000 +00:00","client":"113"},{"date":"2017/03/18 05:00:00.000000 +00:00","client":"130"},{"date":"2017/03/19 05:00:00.000000 +00:00","client":"81"},{"date":"2017/03/20 05:00:00.000000 +00:00","client":"100"},{"date":"2017/03/21 05:00:00.000000 +00:00","client":"119"},{"date":"2017/03/22 05:00:00.000000 +00:00","client":"103"},{"date":"2017/03/23 05:00:00.000000 +00:00","client":"87"},{"date":"2017/03/24 05:00:00.000000 +00:00","client":"149"},{"date":"2017/03/25 05:00:00.000000 +00:00","client":"215"},{"date":"2017/03/26 05:00:00.000000 +00:00","client":"99"},{"date":"2017/03/27 05:00:00.000000 +00:00","client":"120"},{"date":"2017/03/28 05:00:00.000000 +00:00","client":"91"},{"date":"2017/03/29 05:00:00.000000 +00:00","client":"156"},{"date":"2017/03/30 05:00:00.000000 +00:00","client":"96"},{"date":"2017/03/31 05:00:00.000000 +00:00","client":"116"},{"date":"2017/04/01 05:00:00.000000 +00:00","client":"180"},{"date":"2017/04/02 05:00:00.000000 +00:00","client":"113"},{"date":"2017/04/03 05:00:00.000000 +00:00","client":"61"},{"date":"2017/04/04 05:00:00.000000 +00:00","client":"141"},{"date":"2017/04/05 05:00:00.000000 +00:00","client":"157"},{"date":"2017/04/06 05:00:00.000000 +00:00","client":"92"},{"date":"2017/04/07 05:00:00.000000 +00:00","client":"106"},{"date":"2017/04/08 05:00:00.000000 +00:00","client":"172"},{"date":"2017/04/09 05:00:00.000000 +00:00","client":"175"},{"date":"2017/04/10 05:00:00.000000 +00:00","client":"177"},{"date":"2017/04/11 05:00:00.000000 +00:00","client":"171"},{"date":"2017/04/12 05:00:00.000000 +00:00","client":"228"},{"date":"2017/04/13 05:00:00.000000 +00:00","client":"277"},{"date":"2017/04/14 05:00:00.000000 +00:00","client":"338"},{"date":"2017/04/15 05:00:00.000000 +00:00","client":"294"},{"date":"2017/04/16 05:00:00.000000 +00:00","client":"146"},{"date":"2017/04/17 05:00:00.000000 +00:00","client":"140"},{"date":"2017/04/18 05:00:00.000000 +00:00","client":"163"},{"date":"2017/04/19 05:00:00.000000 +00:00","client":"103"},{"date":"2017/04/20 05:00:00.000000 +00:00","client":"206"},{"date":"2017/04/21 05:00:00.000000 +00:00","client":"264"},{"date":"2017/04/22 05:00:00.000000 +00:00","client":"130"},{"date":"2017/04/23 05:00:00.000000 +00:00","client":"101"},{"date":"2017/04/24 05:00:00.000000 +00:00","client":"46"},{"date":"2017/04/25 05:00:00.000000 +00:00","client":"100"},{"date":"2017/04/26 05:00:00.000000 +00:00","client":"217"},{"date":"2017/04/27 05:00:00.000000 +00:00","client":"201"},{"date":"2017/04/28 05:00:00.000000 +00:00","client":"317"},{"date":"2017/04/29 05:00:00.000000 +00:00","client":"212"},{"date":"2017/04/30 05:00:00.000000 +00:00","client":"148"},{"date":"2017/05/01 05:00:00.000000 +00:00","client":"116"},{"date":"2017/05/02 05:00:00.000000 +00:00","client":"146"},{"date":"2017/05/03 05:00:00.000000 +00:00","client":"170"},{"date":"2017/05/04 05:00:00.000000 +00:00","client":"118"},{"date":"2017/05/05 05:00:00.000000 +00:00","client":"222"},{"date":"2017/05/06 05:00:00.000000 +00:00","client":"124"},{"date":"2017/05/07 05:00:00.000000 +00:00","client":"110"},{"date":"2017/05/08 05:00:00.000000 +00:00","client":"94"},{"date":"2017/05/09 05:00:00.000000 +00:00","client":"157"},{"date":"2017/05/10 05:00:00.000000 +00:00","client":"148"},{"date":"2017/05/11 05:00:00.000000 +00:00","client":"99"},{"date":"2017/05/12 05:00:00.000000 +00:00","client":"84"},{"date":"2017/05/13 05:00:00.000000 +00:00","client":"155"},{"date":"2017/05/14 05:00:00.000000 +00:00","client":"159"},{"date":"2017/05/15 05:00:00.000000 +00:00","client":"167"},{"date":"2017/05/16 05:00:00.000000 +00:00","client":"224"},{"date":"2017/05/17 05:00:00.000000 +00:00","client":"177"},{"date":"2017/05/18 05:00:00.000000 +00:00","client":"144"},{"date":"2017/05/19 05:00:00.000000 +00:00","client":"245"},{"date":"2017/05/20 05:00:00.000000 +00:00","client":"158"},{"date":"2017/05/21 05:00:00.000000 +00:00","client":"107"},{"date":"2017/05/22 05:00:00.000000 +00:00","client":"135"},{"date":"2017/05/23 05:00:00.000000 +00:00","client":"107"},{"date":"2017/05/24 05:00:00.000000 +00:00","client":"113"},{"date":"2017/05/25 05:00:00.000000 +00:00","client":"142"},{"date":"2017/05/26 05:00:00.000000 +00:00","client":"298"},{"date":"2017/05/27 05:00:00.000000 +00:00","client":"161"},{"date":"2017/05/28 05:00:00.000000 +00:00","client":"104"},{"date":"2017/05/29 05:00:00.000000 +00:00","client":"143"},{"date":"2017/05/30 05:00:00.000000 +00:00","client":"132"},{"date":"2017/05/31 05:00:00.000000 +00:00","client":"141"},{"date":"2017/06/01 05:00:00.000000 +00:00","client":"191"},{"date":"2017/06/02 05:00:00.000000 +00:00","client":"275"},{"date":"2017/06/03 05:00:00.000000 +00:00","client":"218"},{"date":"2017/06/04 05:00:00.000000 +00:00","client":"130"},{"date":"2017/06/05 05:00:00.000000 +00:00","client":"125"},{"date":"2017/06/06 05:00:00.000000 +00:00","client":"244"},{"date":"2017/06/07 05:00:00.000000 +00:00","client":"219"},{"date":"2017/06/08 05:00:00.000000 +00:00","client":"212"},{"date":"2017/06/09 05:00:00.000000 +00:00","client":"303"},{"date":"2017/06/10 05:00:00.000000 +00:00","client":"157"},{"date":"2017/06/11 05:00:00.000000 +00:00","client":"39"},{"date":"2017/06/12 05:00:00.000000 +00:00","client":"73"},{"date":"2017/06/13 05:00:00.000000 +00:00","client":"84"},{"date":"2017/06/14 05:00:00.000000 +00:00","client":"201"},{"date":"2017/06/15 05:00:00.000000 +00:00","client":"148"},{"date":"2017/06/16 05:00:00.000000 +00:00","client":"156"},{"date":"2017/06/17 05:00:00.000000 +00:00","client":"174"},{"date":"2017/06/18 05:00:00.000000 +00:00","client":"93"},{"date":"2017/06/19 05:00:00.000000 +00:00","client":"117"},{"date":"2017/06/20 05:00:00.000000 +00:00","client":"198"},{"date":"2017/06/21 05:00:00.000000 +00:00","client":"144"},{"date":"2017/06/22 05:00:00.000000 +00:00","client":"123"},{"date":"2017/06/23 05:00:00.000000 +00:00","client":"188"},{"date":"2017/06/24 05:00:00.000000 +00:00","client":"179"},{"date":"2017/06/25 05:00:00.000000 +00:00","client":"113"},{"date":"2017/06/26 05:00:00.000000 +00:00","client":"117"},{"date":"2017/06/27 05:00:00.000000 +00:00","client":"151"},{"date":"2017/06/28 05:00:00.000000 +00:00","client":"155"},{"date":"2017/06/29 05:00:00.000000 +00:00","client":"147"},{"date":"2017/07/01 04:00:00.000000 +00:00","client":"141"},{"date":"2017/07/02 04:00:00.000000 +00:00","client":"120"},{"date":"2017/07/03 04:00:00.000000 +00:00","client":"116"},{"date":"2017/07/04 04:00:00.000000 +00:00","client":"89"},{"date":"2017/07/05 04:00:00.000000 +00:00","client":"109"},{"date":"2017/07/06 04:00:00.000000 +00:00","client":"179"},{"date":"2017/07/07 04:00:00.000000 +00:00","client":"205"},{"date":"2017/07/08 04:00:00.000000 +00:00","client":"126"},{"date":"2017/07/09 04:00:00.000000 +00:00","client":"71"},{"date":"2017/07/10 04:00:00.000000 +00:00","client":"64"},{"date":"2017/07/11 04:00:00.000000 +00:00","client":"93"},{"date":"2017/07/12 04:00:00.000000 +00:00","client":"88"},{"date":"2017/07/13 04:00:00.000000 +00:00","client":"117"},{"date":"2017/07/14 04:00:00.000000 +00:00","client":"191"},{"date":"2017/07/15 04:00:00.000000 +00:00","client":"164"},{"date":"2017/07/16 04:00:00.000000 +00:00","client":"109"},{"date":"2017/07/17 04:00:00.000000 +00:00","client":"103"},{"date":"2017/07/18 04:00:00.000000 +00:00","client":"117"},{"date":"2017/07/19 04:00:00.000000 +00:00","client":"153"},{"date":"2017/07/20 04:00:00.000000 +00:00","client":"134"},{"date":"2017/07/21 04:00:00.000000 +00:00","client":"145"},{"date":"2017/07/22 04:00:00.000000 +00:00","client":"105"},{"date":"2017/07/23 04:00:00.000000 +00:00","client":"126"},{"date":"2017/07/24 04:00:00.000000 +00:00","client":"119"},{"date":"2017/07/25 04:00:00.000000 +00:00","client":"157"},{"date":"2017/07/26 04:00:00.000000 +00:00","client":"164"},{"date":"2017/07/27 04:00:00.000000 +00:00","client":"153"},{"date":"2017/07/28 04:00:00.000000 +00:00","client":"105"},{"date":"2017/07/29 04:00:00.000000 +00:00","client":"142"},{"date":"2017/07/30 04:00:00.000000 +00:00","client":"153"},{"date":"2017/07/31 04:00:00.000000 +00:00","client":"147"},{"date":"2017/08/01 04:00:00.000000 +00:00","client":"158"},{"date":"2017/08/02 04:00:00.000000 +00:00","client":"157"},{"date":"2017/08/03 04:00:00.000000 +00:00","client":"127"},{"date":"2017/08/04 04:00:00.000000 +00:00","client":"220"},{"date":"2017/08/05 04:00:00.000000 +00:00","client":"163"},{"date":"2017/08/06 04:00:00.000000 +00:00","client":"116"},{"date":"2017/08/07 04:00:00.000000 +00:00","client":"82"},{"date":"2017/08/08 04:00:00.000000 +00:00","client":"166"},{"date":"2017/08/09 04:00:00.000000 +00:00","client":"159"},{"date":"2017/08/10 04:00:00.000000 +00:00","client":"163"},{"date":"2017/08/11 04:00:00.000000 +00:00","client":"164"},{"date":"2017/08/12 04:00:00.000000 +00:00","client":"86"},{"date":"2017/08/13 04:00:00.000000 +00:00","client":"179"},{"date":"2017/08/14 04:00:00.000000 +00:00","client":"160"},{"date":"2017/08/15 04:00:00.000000 +00:00","client":"140"},{"date":"2017/08/16 04:00:00.000000 +00:00","client":"222"},{"date":"2017/08/17 04:00:00.000000 +00:00","client":"135"},{"date":"2017/08/18 04:00:00.000000 +00:00","client":"151"},{"date":"2017/08/19 04:00:00.000000 +00:00","client":"157"},{"date":"2017/08/20 04:00:00.000000 +00:00","client":"98"},{"date":"2017/08/21 04:00:00.000000 +00:00","client":"117"},{"date":"2017/08/22 04:00:00.000000 +00:00","client":"130"},{"date":"2017/08/23 04:00:00.000000 +00:00","client":"139"},{"date":"2017/08/24 04:00:00.000000 +00:00","client":"130"},{"date":"2017/08/25 04:00:00.000000 +00:00","client":"185"},{"date":"2017/08/26 04:00:00.000000 +00:00","client":"153"},{"date":"2017/08/27 04:00:00.000000 +00:00","client":"86"},{"date":"2017/08/28 04:00:00.000000 +00:00","client":"104"},{"date":"2017/08/29 04:00:00.000000 +00:00","client":"67"},{"date":"2017/08/30 04:00:00.000000 +00:00","client":"110"},{"date":"2017/08/31 04:00:00.000000 +00:00","client":"124"},{"date":"2017/09/01 04:00:00.000000 +00:00","client":"63"},{"date":"2017/09/02 04:00:00.000000 +00:00","client":"70"},{"date":"2017/09/03 04:00:00.000000 +00:00","client":"123"},{"date":"2017/09/04 04:00:00.000000 +00:00","client":"91"},{"date":"2017/09/05 04:00:00.000000 +00:00","client":"101"},{"date":"2017/09/06 04:00:00.000000 +00:00","client":"52"},{"date":"2017/09/07 04:00:00.000000 +00:00","client":"78"},{"date":"2017/09/08 04:00:00.000000 +00:00","client":"127"},{"date":"2017/09/09 04:00:00.000000 +00:00","client":"100"},{"date":"2017/09/10 04:00:00.000000 +00:00","client":"82"},{"date":"2017/09/11 04:00:00.000000 +00:00","client":"87"},{"date":"2017/09/12 04:00:00.000000 +00:00","client":"91"},{"date":"2017/09/13 04:00:00.000000 +00:00","client":"90"},{"date":"2017/09/14 04:00:00.000000 +00:00","client":"95"},{"date":"2017/09/15 04:00:00.000000 +00:00","client":"175"},{"date":"2017/09/16 04:00:00.000000 +00:00","client":"277"},{"date":"2017/09/17 04:00:00.000000 +00:00","client":"105"},{"date":"2017/09/18 04:00:00.000000 +00:00","client":"119"},{"date":"2017/09/19 04:00:00.000000 +00:00","client":"136"},{"date":"2017/09/20 04:00:00.000000 +00:00","client":"114"},{"date":"2017/09/21 04:00:00.000000 +00:00","client":"129"},{"date":"2017/09/22 04:00:00.000000 +00:00","client":"194"},{"date":"2017/09/23 04:00:00.000000 +00:00","client":"174"},{"date":"2017/09/24 04:00:00.000000 +00:00","client":"110"},{"date":"2017/09/25 04:00:00.000000 +00:00","client":"112"},{"date":"2017/09/26 04:00:00.000000 +00:00","client":"143"},{"date":"2017/09/27 04:00:00.000000 +00:00","client":"131"},{"date":"2017/09/28 04:00:00.000000 +00:00","client":"114"},{"date":"2017/09/29 04:00:00.000000 +00:00","client":"145"},{"date":"2017/09/30 04:00:00.000000 +00:00","client":"116"},{"date":"2017/10/01 04:00:00.000000 +00:00","client":"104"},{"date":"2017/10/02 04:00:00.000000 +00:00","client":"111"},{"date":"2017/10/03 04:00:00.000000 +00:00","client":"141"},{"date":"2017/10/04 04:00:00.000000 +00:00","client":"124"},{"date":"2017/10/05 04:00:00.000000 +00:00","client":"134"},{"date":"2017/10/06 04:00:00.000000 +00:00","client":"177"},{"date":"2017/10/07 04:00:00.000000 +00:00","client":"134"},{"date":"2017/10/08 04:00:00.000000 +00:00","client":"89"},{"date":"2017/10/09 04:00:00.000000 +00:00","client":"97"},{"date":"2017/10/10 04:00:00.000000 +00:00","client":"118"},{"date":"2017/10/11 04:00:00.000000 +00:00","client":"94"},{"date":"2017/10/12 04:00:00.000000 +00:00","client":"81"},{"date":"2017/10/13 04:00:00.000000 +00:00","client":"117"},{"date":"2017/10/14 04:00:00.000000 +00:00","client":"135"},{"date":"2017/10/15 04:00:00.000000 +00:00","client":"110"},{"date":"2017/10/16 04:00:00.000000 +00:00","client":"99"},{"date":"2017/10/17 04:00:00.000000 +00:00","client":"118"},{"date":"2017/10/18 04:00:00.000000 +00:00","client":"94"},{"date":"2017/10/19 04:00:00.000000 +00:00","client":"148"},{"date":"2017/10/20 04:00:00.000000 +00:00","client":"194"},{"date":"2017/10/21 04:00:00.000000 +00:00","client":"191"},{"date":"2017/10/22 04:00:00.000000 +00:00","client":"111"},{"date":"2017/10/23 04:00:00.000000 +00:00","client":"85"},{"date":"2017/10/24 04:00:00.000000 +00:00","client":"98"},{"date":"2017/10/25 04:00:00.000000 +00:00","client":"117"},{"date":"2017/10/26 04:00:00.000000 +00:00","client":"88"},{"date":"2017/10/27 04:00:00.000000 +00:00","client":"132"},{"date":"2017/10/28 04:00:00.000000 +00:00","client":"171"},{"date":"2017/10/29 04:00:00.000000 +00:00","client":"51"},{"date":"2017/10/30 04:00:00.000000 +00:00","client":"65"},{"date":"2017/10/31 04:00:00.000000 +00:00","client":"60"},{"date":"2017/11/01 04:00:00.000000 +00:00","client":"57"},{"date":"2017/11/02 04:00:00.000000 +00:00","client":"60"},{"date":"2017/11/03 04:00:00.000000 +00:00","client":"119"},{"date":"2017/11/04 04:00:00.000000 +00:00","client":"37"},{"date":"2017/11/05 04:00:00.000000 +00:00","client":"28"},{"date":"2017/11/06 04:00:00.000000 +00:00","client":"46"},{"date":"2017/11/07 04:00:00.000000 +00:00","client":"26"},{"date":"2017/11/08 04:00:00.000000 +00:00","client":"21"},{"date":"2017/11/09 04:00:00.000000 +00:00","client":"29"},{"date":"2017/11/10 04:00:00.000000 +00:00","client":"26"},{"date":"2017/11/11 04:00:00.000000 +00:00","client":"32"},{"date":"2017/11/12 04:00:00.000000 +00:00","client":"16"},{"date":"2017/11/13 04:00:00.000000 +00:00","client":"19"},{"date":"2017/11/14 04:00:00.000000 +00:00","client":"29"},{"date":"2017/11/15 04:00:00.000000 +00:00","client":"25"},{"date":"2017/11/16 04:00:00.000000 +00:00","client":"55"},{"date":"2017/11/17 04:00:00.000000 +00:00","client":"42"},{"date":"2017/11/18 04:00:00.000000 +00:00","client":"57"},{"date":"2017/11/19 04:00:00.000000 +00:00","client":"39"},{"date":"2017/11/20 04:00:00.000000 +00:00","client":"37"},{"date":"2017/11/21 04:00:00.000000 +00:00","client":"41"},{"date":"2017/11/22 04:00:00.000000 +00:00","client":"25"},{"date":"2017/11/23 04:00:00.000000 +00:00","client":"5"},{"date":"2017/11/24 04:00:00.000000 +00:00","client":"30"},{"date":"2017/11/25 04:00:00.000000 +00:00","client":"48"},{"date":"2017/11/26 04:00:00.000000 +00:00","client":"26"},{"date":"2017/11/27 04:00:00.000000 +00:00","client":"50"},{"date":"2017/11/28 04:00:00.000000 +00:00","client":"53"},{"date":"2017/11/29 04:00:00.000000 +00:00","client":"75"},{"date":"2017/11/30 04:00:00.000000 +00:00","client":"81"},{"date":"2017/12/01 04:00:00.000000 +00:00","client":"159"},{"date":"2017/12/02 04:00:00.000000 +00:00","client":"71"},{"date":"2017/12/03 04:00:00.000000 +00:00","client":"64"},{"date":"2017/12/04 04:00:00.000000 +00:00","client":"68"},{"date":"2017/12/05 04:00:00.000000 +00:00","client":"72"},{"date":"2017/12/06 04:00:00.000000 +00:00","client":"66"},{"date":"2017/12/07 04:00:00.000000 +00:00","client":"76"},{"date":"2017/12/08 04:00:00.000000 +00:00","client":"76"},{"date":"2017/12/09 04:00:00.000000 +00:00","client":"60"},{"date":"2017/12/10 04:00:00.000000 +00:00","client":"46"},{"date":"2017/12/11 04:00:00.000000 +00:00","client":"61"},{"date":"2017/12/12 04:00:00.000000 +00:00","client":"53"},{"date":"2017/12/13 04:00:00.000000 +00:00","client":"61"},{"date":"2017/12/14 04:00:00.000000 +00:00","client":"59"},{"date":"2017/12/15 04:00:00.000000 +00:00","client":"57"},{"date":"2017/12/16 04:00:00.000000 +00:00","client":"76"},{"date":"2017/12/17 04:00:00.000000 +00:00","client":"44"},{"date":"2017/12/18 04:00:00.000000 +00:00","client":"59"},{"date":"2017/12/19 04:00:00.000000 +00:00","client":"87"},{"date":"2017/12/20 04:00:00.000000 +00:00","client":"106"}]}

/***/ }),

/***/ 495:
/***/ (function(module, exports) {

module.exports = {"data":[{"date":"January","client":"2801"},{"date":"February","client":"3091"},{"date":"March","client":"3259"},{"date":"April","client":"5176"},{"date":"May","client":"4600"},{"date":"June","client":"4674"},{"date":"July","client":"4005"},{"date":"August","client":"4348"},{"date":"September","client":"3544"},{"date":"October","client":"3588"},{"date":"November","client":"1393"},{"date":"December","client":"1262"}]}

/***/ }),

/***/ 496:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-card',[_c('b-row',[_c('b-col',{staticClass:"text-center",attrs:{"lg":"12","md":"12","sm":"12"}},[_c('h1',{staticClass:"display-3"},[_vm._v("Data Insights")]),_vm._v("\n               WiFi has given us the freedom to work, play, and connect in any way we’d like. "),_c('br'),_vm._v("\n               Connection brings us all together and there is an underlying, fundamental reliance on this connectivity."),_c('br'),_vm._v(" "),_c('p',[_vm._v("How do these connections impact our visitors to the beautiful, historic Downtown Mall?")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"width":"80","height":"80","src":"https://image.ibb.co/chYLEn/Picture1small.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Are there insights that can be gained from visualizing this data?")]),_c('br'),_c('br')])],1)],1),_vm._v(" "),_c('b-card',[_c('b-row',[_c('b-col',{staticClass:"text-center mt-4 mb-4",attrs:{"lg":"12","md":"12","sm":"12"}},[_c('h1',{staticClass:"display-4"},[_vm._v("Access & Accessibility")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":"https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png"}}),_vm._v(" "),_c('h4',{staticClass:"font-weight-bold"},[_vm._v(" Scope of the Data ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',{staticClass:"font-weight-normal"},[_vm._v(" Data provided for this challenge spanned one year starting in January of 2017 and was anonymized. The data contained aggregated daily counts of WiFi users and sessions. In addition, there was 4-hour aggregated usage data in bytes collected from the city-provided, free WiFi on the Downtown Mall.")]),_vm._v(" "),_c('h5',{staticClass:"font-weight-normal"},[_vm._v(" Additional data sources incorporated into the following analyses contain insights derived from local weather, events, and holidays.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":"https://preview.ibb.co/juNY4x/mallwifi.png"}}),_c('br'),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":"https://image.ibb.co/h23nQS/HOMEPAGE_ARROW_UP.png"}})])],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{staticClass:"text-center",attrs:{"md":"4","sm":"8"}},[_c('img',{staticClass:"img-fluid-tiles",attrs:{"src":"https://preview.ibb.co/ntPmun/Yearly_Users.png"}})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"md":"4","sm":"8"}},[_c('img',{staticClass:"img-fluid-tiles",attrs:{"src":"https://preview.ibb.co/bZZ877/yearlysessions.png"}})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"md":"4","sm":"8"}},[_c('img',{staticClass:"img-fluid-tiles",attrs:{"src":"https://image.ibb.co/fOYxOp/yearlydatausage.png"}})])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-row',{},[_c('b-col',{staticClass:"offset-lg-1 text-center",attrs:{"lg":"2","md":"4","sm":"3"}},[_c('div',{staticClass:"text-muted"},[_vm._v("Monthly Average")]),_vm._v(" "),_c('strong',[_c('h5',[_vm._v("3,478")]),_vm._v(" Users")]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs mt-2",attrs:{"precision":1,"variant":"success","value":100}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"lg":"2","md":"4","sm":"3"}},[_c('div',{staticClass:"text-muted"},[_vm._v("Daily Average")]),_vm._v(" "),_c('strong',[_c('h5',[_vm._v("118")]),_vm._v(" Users")]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs mt-2",attrs:{"precision":1,"variant":"info","value":100}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"lg":"2","md":"4","sm":"3"}},[_c('div',{staticClass:"text-muted"},[_vm._v("Monthly Average")]),_vm._v(" "),_c('strong',[_c('h5',[_vm._v("29,738")]),_vm._v(" Sessions")]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs mt-2",attrs:{"precision":1,"variant":"warning","value":100}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"lg":"2","md":"6","sm":"3"}},[_c('div',{staticClass:"text-muted"},[_vm._v("Daily Average")]),_vm._v(" "),_c('strong',[_c('h5',[_vm._v("1,019")]),_vm._v(" Sessions")]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs mt-2",attrs:{"precision":1,"variant":"danger","value":100}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"lg":"2","md":"6","sm":"3"}},[_c('div',{staticClass:"text-muted"},[_vm._v("Yearly Data")]),_vm._v(" "),_c('strong',[_c('h5',[_vm._v("1,071,854 (KB)")]),_vm._v(" Downloaded")]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs mt-2",attrs:{"precision":1,"value":100}})],1)],1)],1)],1),_vm._v(" "),_c('b-card',[_c('b-row',[_c('b-col',{staticClass:"text-center mt-4",attrs:{"lg":"12","md":"12","sm":"12"}},[_c('h1',{staticClass:"display-4"},[_vm._v("Patterns & Trends")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":"https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png"}}),_vm._v(" "),_c('h4',{staticClass:"font-weight-bold"},[_vm._v(" What do these trends tell us? ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',{staticClass:"font-weight-normal"},[_vm._v(" A monthly average of 3,478 users was observed for the whole dataset. The peak time for WiFi visitors on the downtown mall is during the spring when the weather gets warmer (5,176 users in the month of April). Visitors and usage decrease as the year progresses, with an all-time low in November (1,393 users) and December* (1,262 users).")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h7',{staticClass:"font-weight-light",attrs:{"color":"#666"}},[_vm._v(" *December is not a complete month in this dataset.")])],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12","md":"12","sm":"12"}},[_c('h4',{staticClass:"text-center justify-content-center align-self-center"},[_vm._v(" Count of Monthly Wifi Users on the Downtown Mall ")]),_vm._v(" "),_c('line-example')],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-card',[_c('b-col',{staticClass:"text-center justify-content-center align-self-center ",attrs:{"lg":"12","md":"12","sm":"12"}},[_c('b-row',{staticClass:"text-center justify-content-center align-self-center mt-4"},[_c('h1',{staticClass:"display-4"},[_vm._v("Impact of Weather")]),_vm._v(" "),_c('br'),_c('br')]),_vm._v(" "),_c('b-row',{staticClass:"text-center justify-content-center align-self-center mt-4"},[_c('img',{staticClass:"img-fluid text-center justify-content-center align-self-center mt-2",attrs:{"src":"https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png"}})]),_vm._v(" "),_c('b-row',{staticClass:"text-center justify-content-center align-self-center mt-4"},[_c('h5',{staticClass:"font-weight-normal text-center justify-content-center align-self-center mt-4"},[_vm._v(" \n              The Charlottesville Downtown Mall is an open air pedestrian mall. "),_c('br'),_vm._v("\n            As you might expect, the weather has a significant impact on WiFi usage on the Downtown Mall.")])])],1),_vm._v(" "),_c('b-col',{staticClass:"text-center justify-content-center align-self-center ",attrs:{"lg":"12","md":"12","sm":"12"}},[_c('img',{staticClass:"p-4 img-fluid",attrs:{"src":"static/img/weather_wifi.png"}})])],1),_vm._v(" "),_c('b-card',[_c('b-row',{staticClass:"p-4"},[_c('b-col',{staticClass:"text-center mt-4",attrs:{"lg":"12","md":"12","sm":"12"}},[_c('h1',{staticClass:"display-4"},[_vm._v("Mobile App Usage")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":"https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png"}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center justify-content-center align-self-center mt-2\n           mb-4",attrs:{"lg":"12","md":"12","sm":"12"}},[_c('img',{staticClass:"p-4 img-fluid",attrs:{"src":"https://image.ibb.co/nO7ZHH/application_usage.png"}})])],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{staticClass:"text-center",attrs:{"lg":"4","md":"6","sm":"12"}},[_c('h5',{},[_c('i',{staticClass:"icon-social-facebook icons font-2xl"}),_vm._v(" Social Media App Usage (%) ")]),_vm._v(" "),_c('pie-example',{staticClass:"p-4 img-fluid",attrs:{"labels":_vm.labels_app_social,"dataPoints":_vm.data_app_social,"pieColors":_vm.pie_colors_app_social}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"lg":"4","md":"6","sm":"12"}},[_c('h5',{},[_c('i',{staticClass:"icon-social-youtube icons font-2xl"}),_vm._v(" Video App Usage (%)")]),_vm._v(" "),_c('pie-example',{staticClass:"p-4 img-fluid",attrs:{"labels":_vm.labels_app_video,"dataPoints":_vm.data_app_video,"pieColors":_vm.pie_colors_app_video}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{staticClass:"text-center",attrs:{"lg":"4","md":"6","sm":"12"}},[_c('h5',{},[_c('i',{staticClass:"icon-screen-smartphone icons font-2xl"}),_vm._v(" WiFi Users per Year by Device Type")]),_vm._v(" "),_c('pie-example',{staticClass:"p-4 img-fluid",attrs:{"labels":_vm.labels_mobile,"dataPoints":_vm.data_mobile,"pieColors":_vm.pie_colors_mobile}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"lg":"4","md":"6","sm":"12"}},[_c('h5',{},[_c('i',{staticClass:"icon-social-spotify icons font-2xl"}),_vm._v(" Music App Usage (%) ")]),_vm._v(" "),_c('pie-example',{staticClass:"p-4 img-fluid",attrs:{"labels":_vm.labels_app_music,"dataPoints":_vm.data_app_music,"pieColors":_vm.pie_colors_app_music}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',{staticClass:"p-2"},[_c('b-col',{attrs:{"md":"2","sm":"0"}}),_vm._v(" "),_c('b-col',{staticClass:"text-center justify-content-center align-self-center",attrs:{"lg":"8","md":"8","sm":"12"}},[_c('b-card',{staticClass:"border-secondary mt-2",attrs:{"header":"<h4><b>What could we do with this data?</b></h4>"}},[_vm._v("\n              - Hosting events to draw more Apple or tech users to the downtown mall may bring in greater volume for tech business and increase the number of WiFi users."),_c('br'),_vm._v("\n              - Device repair stores can utilize this data to better serve their customers and provide tailored services."),_c('br'),_vm._v("\n              - Consider opening a technology related store, such as an Apple store, on the mall."),_c('br'),_vm._v("\n              - Alternatively, bring in these specific vendors during key technology related events such as the TomTom Festival."),_c('br'),_c('br'),_vm._v(" "),_c('b',[_c('u',[_vm._v("Top Mobile Device Insights")])]),_c('br'),_vm._v("\n                - Apple dominates with the most users per device."),_c('br'),_vm._v(" \n                - Samsung and LG additionally make up a large percentage of total device usage."),_c('br'),_vm._v("\n                - Facebook is the most frequented social media application. "),_c('br'),_vm._v("\n                - Youtube has the highest number of for video streaming and iTunes is most popular for audio content. "),_c('br')])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"2","sm":"0"}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-card',[_c('b-row',{staticClass:"p-4 mb-4"},[_c('b-col',{staticClass:"text-center mt-4 mb-4",attrs:{"lg":"12","md":"12","sm":"12"}},[_c('h1',{staticClass:"display-4"},[_vm._v("Events")]),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":"https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h5',{staticClass:"font-weight-normal"},[_vm._v(" Many of the events on the downtown mall brought in greater numbers of WiFi users. Events with a focus on technology and music seem to resonate strongly within the Charlottesville community. Even for the least active month of the year, November, the Fridays After Five event on Nov 3rd brought in the highest number of daily users for that month. When reviewing the following infographic, keep in mind that, for comparison, the average daily WiFi user count on the Downtown Mall is 118 users. ")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center",attrs:{"lg":"12","md":"12","sm":"12"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"https://image.ibb.co/i9G5Px/events_infographic.png"}})])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{staticClass:"text-center",attrs:{"lg":"4","md":"4","sm":"12"}},[_c('h6',{},[_vm._v("Average WiFi Users for Specific Event Categories")]),_vm._v(" "),_c('pie-example',{staticClass:"img-fluid",attrs:{"labels":_vm.labels_events,"dataPoints":_vm.data_events,"pieColors":_vm.green_colors_events}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"lg":"1","md":"1","sm":"0"}}),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"lg":"4","md":"4","sm":"12"}},[_c('h6',{},[_vm._v("Average WiFi Users by Day of Week")]),_vm._v(" "),_c('bar-example',{staticClass:"img-fluid",attrs:{"labels":_vm.labels_dates,"dataPoints":_vm.data_dates}})],1)],1)],1),_vm._v(" "),_c('b-card',[_c('b-row',[_c('b-col',{staticClass:"justify-content-center text-center",attrs:{"lg":"12","md":"12","sm":"12"}},[_c('div',{staticClass:"p-4"},[_c('h1',{staticClass:"display-3"},[_vm._v("Conclusions")]),_vm._v(" "),_c('h5',[_vm._v("We saw the largest increase in number of WiFi users when there were community driven events. We believe we can empower the businesses to attract community to engage with them to help promote other activities, for the benefit of both the business and community at large. Community events, such as Fridays After Five, consistently draw many people to the Downtown Mall. Events such as these can be expanded to bring the community and businesses together. Larger festivals such as the Tom Tom Festival even draw people from outside of Charlottesville.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"width":"180","height":"180","src":"static/img/business_chain_people_logo.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-card',{staticClass:"border-secondary mt-2 img-fluid",attrs:{"header":"<h5><b>Five key insights that were revealed from the data:</b></h5>"}},[_vm._v("\n\n          1. "),_c('b',[_vm._v("Know your visitors:")]),_vm._v(" They tend to use Apple devices and businesses on the Downtown mall could leverage this information by creating more Apple-targeted products or offering related services."),_c('br'),_vm._v("\n          2. "),_c('b',[_vm._v("Engage with your visitors")]),_vm._v(" on platforms they use. One way is to have business incentivize users to engage over social media (Facebook or Instagram for example)."),_c('br'),_vm._v("\n          3. "),_c('b',[_vm._v("Impact of Weather:")]),_vm._v(" Provide rainy day discounts because the data has shown that visitors are less likely to come out (post it on your Facebook, because they use Facebook)."),_c('br'),_vm._v("\n          4. "),_c('b',[_vm._v("Day of the Week:")]),_vm._v(" Knowing Sundays are a low traffic day, perhaps encourage restaurants to offer a Brunch on Sundays."),_c('br'),_vm._v("\n          5. "),_c('b',[_vm._v("Type of Event:")]),_vm._v(" Continue to draw in visitors and wifi users through annual events. Music and technology related events tend to draw larger crowds."),_c('br'),_c('br'),_vm._v("\n\n          When you better understand your users you are better able to cater to their needs. It's clear from the data that community events are what drives the highest usage and "),_c('b',[_vm._v("connectivity")]),_vm._v(" between businesses and WiFi users who have the potential to shop there."),_c('br'),_c('br')])],1)])],1)],1),_vm._v(" "),_c('b-card',{staticClass:"text-center justify-content-center align-self-center img-fluid"},[_vm._v("\n      If you would like to download the \"Events on the Downtown Mall\" or \"What can we learn from this data?\" Infographic, please use the following links:"),_c('br'),_vm._v(" "),_c('b-row',{staticClass:"justify-content-center text-center",attrs:{"lg":"12","md":"12","sm":"12"}},[_c('b-col',{attrs:{"lg":"6","md":"6","sm":"12"}},[_c('a',{staticClass:"btn btn-primary m-4",attrs:{"href":"https://image.ibb.co/i9G5Px/events_infographic.png","download":"events_and_wifi_infographic.png"}},[_vm._v("Download \"Events\" Infographic")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6","md":"6","sm":"12"}},[_c('a',{staticClass:"btn btn-primary m-4",attrs:{"href":"https://image.ibb.co/jCXOBc/opening_infographic.png","download":"events_and_wifi_infographic.png"}},[_vm._v("Download \"Impact\" Infographic")])])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Model_vue__ = __webpack_require__(249);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11699e2c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Model_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Model_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11699e2c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Model_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11699e2c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Model_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarSessions_vue__ = __webpack_require__(250);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarSessions_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',{staticClass:"bg-gray-100"},[_c('b-col',{staticClass:"text-center mb-3",attrs:{"md":"12"}},[_c('br'),_vm._v(" "),_c('h1',{staticClass:"display-3 font-weight-bold"},[_vm._v("Model Results")]),_vm._v(" "),_c('p'),_c('h3',{staticClass:"font-weight-normal"},[_vm._v(" Our predictive model resulted in a mean absolute percentage error (MAPE) of: ")]),_vm._v(" "),_c('p'),_c('h1',{staticClass:"display-3 font-weight-bold"},[_vm._v("12%")]),_vm._v(" "),_c('img',{attrs:{"src":"https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',{staticClass:"font-weight-normal"},[_vm._v(" This equates to an approximate accuracy of: ")]),_vm._v(" "),_c('p'),_c('h1',{staticClass:"display-3 font-weight-bold"},[_vm._v("88%")]),_vm._v(" "),_c('img',{attrs:{"src":"https://image.ibb.co/h23nQS/HOMEPAGE_ARROW_UP.png"}}),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',{staticClass:"background-color-gray"},[_c('b-col',{staticClass:"text-center mb-3",attrs:{"md":"12"}},[_c('h3',{staticClass:"font-weight-normal"},[_vm._v(" We predict that during the week of 12/23/17 - 12/31/17 there will be:")])])],1),_vm._v(" "),_c('div',{staticClass:"row justify-content-center mt-3"},[_c('div',{staticClass:"col-sm-6 col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-block text-center"},[_c('div',{staticClass:"text-muted small text-uppercase font-weight-bold"},[_vm._v("Number of Visitors")]),_vm._v(" "),_c('div',{staticClass:"h2 py-1 text-blue"},[_vm._v("243")]),_vm._v(" "),_c('div',{staticClass:"chart-wrapper"},[_c('bar-example')],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-block text-center"},[_c('div',{staticClass:"text-muted small text-uppercase font-weight-bold"},[_vm._v("Number of Sessions")]),_vm._v(" "),_c('div',{staticClass:"h2 py-1"},[_vm._v("1743")]),_vm._v(" "),_c('div',{staticClass:"chart-wrapper"},[_c('bar-sessions')],1)])])])]),_vm._v(" "),_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"8"}},[_c('b-card',[_c('line-example')],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"bg-gray-100",attrs:{"id":"InstructionsForAstaea"}},[_c('b-col',{staticClass:"text-center mb-3",attrs:{"md":"12"}},[_c('br'),_vm._v(" "),_c('h1',{staticClass:"display-3 font-weight-bold"},[_vm._v("Instructions for Astraea")]),_vm._v(" "),_c('p'),_c('h3',{staticClass:"font-weight-normal"},[_vm._v(" To retrieve files & instructions for validating our model please log in below: ")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png"}})]),_c('h3',{staticClass:"display-5 font-weight-bold"},[_vm._v("log in widget will go here & redirect to new page")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"https://image.ibb.co/h23nQS/HOMEPAGE_ARROW_UP.png"}}),_vm._v(" "),_c('br')])])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82b46350_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
function injectStyle (context) {
  __webpack_require__(501)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82b46350_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82b46350_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 501:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('main',{staticClass:"main",staticStyle:{"margin-left":"0!important"}},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('b-row',{staticClass:"bg-gray-100"},[_c('b-col',{staticClass:"text-center mb-3",attrs:{"md":"12"}},[_c('br'),_vm._v(" "),_c('h1',{staticClass:"display-3 font-weight-bold"},[_vm._v("Open Data Challenge")]),_vm._v(" "),_c('p'),_c('h3',{staticClass:"font-weight-normal"},[_vm._v(" CHARLOTTESVILLE, VA ")]),_vm._v(" "),_c('p'),_vm._v("\n\n                  This is the first \"City Open Data Challenge\" co-sponsored by "),_c('a',{attrs:{"href":"https://www.astraea.earth/"}},[_vm._v("Astraea")]),_vm._v(" with the goal of gaining a better understanding of the pedestrian use of the Downtown Mall. "),_c('p',[_vm._v(" This website shares discoveries related to WiFi usage on the Downtown Mall. ")]),_c('br'),_c('br'),_vm._v(" "),_c('img',{staticClass:"img-fluid",attrs:{"src":"https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png"}})])],1),_vm._v(" "),_c('b-row',{staticClass:"bg-gray-100 justify-content-center"},[_c('b-col',{staticClass:"text-center",attrs:{"sm":"6","lg":"2"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"https://image.ibb.co/m4Z7qS/generalstat1.png"}})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"sm":"6","lg":"2"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"https://image.ibb.co/ejzwjn/generalstat2.png"}})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"sm":"6","lg":"2"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"https://image.ibb.co/mUGbjn/generalstats4.png"}})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"sm":"6","lg":"2"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"https://preview.ibb.co/fgCKen/8_Wifi.png"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])],1),_vm._v(" "),_c('b-row',{staticClass:"bg-gray-100 justify-content-center"},[_c('b-col',{staticClass:"text-center mb-3",attrs:{"lg":"8","md":"8","sm":"12"}},[_c('carousel',{staticClass:"img-fluid",attrs:{"perPage":1,"navigateTo":_vm.someLocalProperty,"navigationEnabled":true,"navigationPrevLabel":"","navigationNextLabel":"","paginationColor":"#9dacb1"}},[_c('slide',[_c('img',{staticClass:"w-90 img-fluid",attrs:{"src":"https://image.ibb.co/gAW5Px/panel1.png","alt":"Why"}})]),_vm._v(" "),_c('slide',[_c('img',{staticClass:"w-90 img-fluid",attrs:{"src":"https://image.ibb.co/kRvArc/panel2.png","alt":"Understand"}})]),_vm._v(" "),_c('slide',[_c('img',{staticClass:"w-90 img-fluid",attrs:{"src":"https://image.ibb.co/eXkArc/panel3.png","alt":"Grow"}})]),_vm._v(" "),_c('slide',[_c('img',{staticClass:"w-90 img-fluid",attrs:{"src":"https://image.ibb.co/it8Vrc/panel4.png","alt":"Improve"}})]),_vm._v(" "),_c('slide',[_c('img',{staticClass:"w-90 img-fluid",attrs:{"src":"https://image.ibb.co/hjT8cH/panel5.png","alt":"Give"}})])],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col",attrs:{"md":"1"}}),_vm._v(" "),_c('div',{staticClass:"col text-center justify-content-center align-self-center"},[_c('router-link',{staticClass:"btn btn-primary btn-block btn-color-orange p-4 mb-4 ",attrs:{"to":'story'}},[_vm._v("VIEW OUR STORY")])],1),_vm._v(" "),_c('div',{staticClass:"col",attrs:{"md":"1"}})]),_vm._v(" "),_c('b-card',[_c('b-row',[_c('b-col',{staticClass:"text-center",attrs:{"md":"12"}},[_c('h1',{staticClass:"display-4"},[_vm._v("Meet the Team")]),_vm._v(" "),_c('p'),_c('h2',{staticClass:"font-weight-normal"},[_vm._v(" \"H.A.C.K.D.\" ")]),_vm._v(" "),_c('p')])],1),_vm._v(" "),_c('b-row',{},[_c('b-col',{staticClass:"text-center mb-3",attrs:{"md":"12"}},[_c('p',[_vm._v("\n                     We would like to extend our sincere thanks and appreciation to "),_c('a',{attrs:{"href":"https://www.astraea.earth/"}},[_vm._v("Astraea")]),_vm._v(" for creating and co-sponsoring this wonderful competition. We are honored to be among the participants and excited to share our ideas and results.\n                  ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"justify-content-center",attrs:{"lg":"2","md":"2"}},[_c('b-col',{staticClass:"text-center",attrs:{"sm":"6","lg":"2"}},[_c('img',{staticClass:"image--cover",attrs:{"src":"https://image.ibb.co/m2zNpn/Halee_Mason.jpg"}}),_vm._v(" "),_c('h4',[_c('a',{attrs:{"href":"https://www.linkedin.com/in/haleemason/"}},[_vm._v("Halee Mason")])])]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"sm":"6","lg":"2"}},[_c('img',{staticClass:"image--cover",attrs:{"src":"https://image.ibb.co/fCbDvS/Anna_Godwin.jpg","alt":""}}),_vm._v(" "),_c('h4',[_c('a',{attrs:{"href":"https://www.linkedin.com/in/anna-godwin-a51284140/"}},[_vm._v("Anna Godwin")])])]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"sm":"6","lg":"2"}},[_c('img',{staticClass:"image--cover",attrs:{"src":"https://image.ibb.co/iArfaS/Cory_Everington.jpg","alt":""}}),_vm._v(" "),_c('h4',[_c('a',{attrs:{"href":"https://www.linkedin.com/in/coryeverington/"}},[_vm._v("Cory Everington")])])]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"sm":"6","lg":"2"}},[_c('img',{staticClass:"image--cover",attrs:{"src":"static/img/Kazlin_Mason.jpg","alt":""}}),_vm._v(" "),_c('h4',[_c('a',{attrs:{"href":"https://www.linkedin.com/in/kazlin/"}},[_vm._v("Kazlin Mason")])])]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"sm":"6","lg":"2"}},[_c('img',{staticClass:"image--cover",attrs:{"src":"https://image.ibb.co/fq0v9n/Danny_Brady.jpg","alt":""}}),_vm._v(" "),_c('h4',[_c('a',{attrs:{"href":"https://www.linkedin.com/in/danny-brady-514965a4/"}},[_vm._v("Danny Brady")])])])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('br')],1)],1),_vm._v(" "),_c('AppAside')],1),_vm._v(" "),_c('AppFooter',{staticClass:"m-0 height-50"})],1)}
var staticRenderFns = []


/***/ }),

/***/ 503:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Data_vue__ = __webpack_require__(252);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5feba502_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Data_vue__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Data_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5feba502_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Data_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5feba502_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Data_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-card',[_c('b-row',[_c('b-col',{staticClass:"text-center",attrs:{"md":"12"}},[_c('h1',{staticClass:"display-3"},[_vm._v("Data Deep Dive")]),_vm._v(" "),_c('b-row',{staticClass:"w-100 text-center justify-content-center align-self-center",attrs:{"md":"12"}},[_c('img',{attrs:{"src":"https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png"}})]),_vm._v(" "),_c('b-card',{staticClass:"border-primary",attrs:{"variant":"accent-info","header":"Card with accent"}},[_vm._v("\n              The statistics and infographics created on the previous page were generated from exploring the data. It is through data understanding and exploration that valueable insights can be gained."),_c('br'),_c('br'),_vm._v("\n              \n              For example, it is intuitive to most that weather will impact visitor counts on the Downtown Mall, but being able to quantify the impact is how this wifi data can become most useful. The \"Weather and Wifi\" infographic aimed to do just that. It also confirmed those suspicions."),_c('br'),_vm._v("\n\n              Most business owners know that wifi users on the downtown mall most likely use social media apps or visit media delivery websites, such as YouTube. Now the data has been explored to understand these usage patterns. "),_c('br'),_vm._v("\n\n              This page serves as an exploration and additional page to dive deeper into the data."),_c('br')]),_vm._v(" "),_c('b-row',{staticClass:"w-100 text-center justify-content-center align-self-center",attrs:{"md":"12"}},[_c('img',{attrs:{"src":"https://image.ibb.co/h23nQS/HOMEPAGE_ARROW_UP.png"}})])],1)],1)],1),_vm._v(" "),_c('b-card',[_c('b-row',[_c('b-col',{staticClass:"text-center",attrs:{"md":"12"}},[_c('img',{attrs:{"src":"https://preview.ibb.co/eGVR27/understanding_patterns.png"}})])],1),_vm._v(" "),_c('b-row',{staticClass:"text-center justify-content-center align-self-center"},[_c('b-card',{staticClass:"border-secondary mt-2",attrs:{"header":"Scope of Exploration"}},[_vm._v("\n         Three-hundred and fifty three days were analyzed during 2017 to learn about the usage of Wifi on the downtown mall. Wifi users were denoted as \"clients\" and the number of clients per day was provided. Each day, a certain number of wifi sessions were also recorded. Finally, the total kilobytes downloaded and total kilobytes used during those sessions were tracked. \n      ")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('line-example')],1)],1)],1),_vm._v(" "),_c('b-card',[_c('b-row',{staticClass:"p-4"},[_c('b-col',{staticClass:"text-center justify-content-center align-self-center",attrs:{"md":"6"}},[_c('b-card',{staticClass:"border-secondary mt-2",attrs:{"header":"Key Takeaways from Mobile App Usage"}},[_vm._v("\n           It was through the exploration of additional data sources. \n          ")])],1),_vm._v(" "),_c('b-col',{staticClass:"text-center justify-content-center align-self-center",attrs:{"md":"6"}},[_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"md":"12"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"https://image.ibb.co/c0xQc7/Top_20_Mobile_Apps.png"}})])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center justify-content-center align-self-center",attrs:{"md":"4"}},[_c('h4',{},[_vm._v("Social Media App Usage")]),_vm._v(" "),_c('pie-example',{attrs:{"labels":_vm.labels_app_social,"dataPoints":_vm.data_app_social}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-center justify-content-center align-self-center",attrs:{"md":"4"}},[_c('h4',{},[_vm._v("Music App Usage")]),_vm._v(" "),_c('pie-example',{attrs:{"labels":_vm.labels_app_music,"dataPoints":_vm.data_app_music}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-center justify-content-center align-self-center",attrs:{"md":"4"}},[_c('h4',{},[_vm._v("Video App Usage")]),_vm._v(" "),_c('pie-example',{attrs:{"labels":_vm.labels_app_video,"dataPoints":_vm.data_app_video}})],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-card',[_c('b-col',{staticClass:"text-center justify-content-center align-self-center",attrs:{"md":"12"}},[_c('img',{staticClass:"img-fluid",attrs:{"src":"https://image.ibb.co/kdvmH7/Top_10_Mobile_Brands.png"}})]),_vm._v(" "),_c('b-row',{staticClass:"p-4"},[_c('b-col',{staticClass:"text-center justify-content-center align-self-center",attrs:{"md":"8"}},[_c('b-card',{staticClass:"border-secondary mt-2",attrs:{"header":"What could we do with this data?"}},[_vm._v("\n           - Events to draw more Apple or tech users to the downtown mall may bring in greater volume for tech business and increase the number of wifi users.\n            "),_c('br'),_vm._v(" - Consider opening a technology related store, such as an Apple store or device repair store, on the mall. \n            "),_c('br'),_vm._v(" - Alternatively, bring in these specific vendors during key technology related events such as the TomTom Festival.\n         ")])],1),_vm._v(" "),_c('b-col',{staticClass:"text-center justify-content-center align-self-center",attrs:{"md":"4"}},[_c('pie-example',{attrs:{"labels":_vm.labels_mobile,"dataPoints":_vm.data_mobile}}),_vm._v(" "),_c('b-card',{staticClass:"border-secondary",attrs:{"header":"Top Mobile Device Key Takeaways"}},[_vm._v("\n             - Apple dominates with the most users per device (29.49% of all users)."),_c('br'),_vm._v(" \n             - Samsung and LG additionally make up a large percentage of total device usage."),_c('br')])],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center",attrs:{"md":"8"}},[_c('img',{staticClass:"w-100",attrs:{"src":"static/img/events_1.png"}})]),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"md":"4"}},[_c('b-card',{staticClass:"border-secondary",attrs:{"header":"Key Events"}},[_vm._v("\n           Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n         ")])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center justify-content-center align-self-center",attrs:{"md":"12"}},[_c('div',{staticClass:"chart-wrapper"},[_c('h6',{},[_vm._v("Yearly Number of Clients By Event Type")]),_vm._v(" "),_c('pie-example',{attrs:{"labels":_vm.labels_events,"dataPoints":_vm.data_events}})],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center justify-content-center align-self-center",attrs:{"md":"12"}},[_c('bar-example',{attrs:{"labels":_vm.labels_dates,"dataPoints":_vm.data_dates}})],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ 56:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineExample_vue__ = __webpack_require__(126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineExample_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarExample_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(5);
/* script */


/* template */
var __vue_render__, __vue_static_render_fns__
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BarExample_vue__["a" /* default */],
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(93);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["d" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["e" /* Sidebar */],
    AppAside: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Aside */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components___["c" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components___["b" /* Breadcrumb */]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),

/***/ 92:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  items: [{
    name: 'Home',
    url: '/',
    icon: 'icon-home'
  }, {
    name: 'Story',
    url: '/story',
    icon: 'icon-book-open'
  }]
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_vue__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(429);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */










/***/ }),

/***/ 94:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-aside'
});

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-footer'
});

/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-header',
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    }
  }
});

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SidebarNavLabel__ = __webpack_require__(426);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],
    SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__["a" /* default */],
    SidebarNavDivider: __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__["a" /* default */],
    SidebarNavLabel: __WEBPACK_IMPORTED_MODULE_9__SidebarNavLabel__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ })

},[253]);


// WEBPACK FOOTER //
// static/js/app.6e37d73acf4024749910.js